import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { BUDGET_LINE_ITEMS } from "./apiRoutes";

interface UseGetGlEntriesByBudgetIdProps {
  budgetId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getGlEntriesByBudgetId = async (budgetId: string) =>
  await axiosAuth.get(`${BUDGET_LINE_ITEMS(budgetId)}/available-gl-entries`);

const useGetGlEntriesByBudgetId = ({
  queryParams,
  budgetId,
}: UseGetGlEntriesByBudgetIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["gl-entries", budgetId],
    queryFn: () => getGlEntriesByBudgetId(budgetId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!budgetId && (queryParams?.enabled ?? true),
  });
};

export default useGetGlEntriesByBudgetId;
